import React from "react";

interface FooterProps {
  variant?: "light" | "dark";
}

function Footer({ variant = "light" }: FooterProps) {
  const isDark = variant === "dark";

  return (
    <footer className={`relative z-10 border-t mt-auto ${
      isDark
        ? "border-gray-200 bg-gray-50"
        : "border-white/20 bg-white/5 backdrop-blur-sm"
    }`}>
      <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-6 py-4">
        <div className={`text-center text-xs flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 ${
          isDark ? "text-gray-500" : "text-white/60"
        }`}>
          <span>© 2026 Octerm Technologies, Inc.</span>
          <div className="flex items-center justify-center gap-2 sm:gap-4">
            <a
              href="/terms"
              className={`transition-colors duration-200 hover:underline ${
                isDark
                  ? "hover:text-gray-700"
                  : "hover:text-white/80"
              }`}
            >
              Terms of Service
            </a>
            <span>|</span>
            <a
              href="/policy"
              className={`transition-colors duration-200 hover:underline ${
                isDark
                  ? "hover:text-gray-700"
                  : "hover:text-white/80"
              }`}
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;